import BaseAPI, { querySuffix } from "./BaseAPI";

export default class ChatAPI extends BaseAPI {
    constructor(emitter) {
        super(emitter, "chat/groups", "chat");
    }

    async List(params = {}, options = {}) {
        const groups = [];
        let pageToken = "";
        do {
            const page = await this._request(
                "get",
                this._url(querySuffix({ ...params, limit: 100, page_token: pageToken })),
                null,
                { ...options, rawData: true }
            );
            groups.push(...(page.data || []));
            pageToken = page.next_page_token || "";
        } while (pageToken);
        return groups;
    }

    async Summary(options = {}) {
        const rows = [];
        let pageToken = "";
        do {
            const page = await this._request(
                "get",
                this._url().replace(/\/groups$/, "/summary") +
                    querySuffix({ page_token: pageToken }),
                null,
                { ...options, rawData: true }
            );
            rows.push(...(page.data || []));
            pageToken = page.next_page_token || "";
        } while (pageToken);
        return rows;
    }

    async UpdateState(id, payload) {
        return this._request("put", this._url(`/${id}/state`), payload);
    }

    async MembersPage(id, params = {}, options = {}) {
        const page = await this._request(
            "get",
            this._url(`/${id}/members${querySuffix({ limit: 20, ...params })}`),
            null,
            { ...options, rawData: true }
        );
        return { data: page.data || [], next_page_token: page.next_page_token || "" };
    }

    async MessagesPage(id, params = {}, options = {}) {
        const page = await this._request(
            "get",
            this._url(`/${id}/messages${querySuffix({ limit: 50, ...params })}`),
            null,
            { ...options, rawData: true }
        );
        return {
            data: page.data || [],
            next_page_token: page.next_page_token || "",
            has_newer: Boolean(page.has_newer)
        };
    }

    async SendMessage(id, payload, idempotencyKey) {
        const message = await this._request("post", this._url(`/${id}/messages`), payload, {
            headers: { "Idempotency-Key": idempotencyKey }
        });
        this._emit("message", id);
        return message;
    }
}
